/**
 * Cognito Hosted UI のログイン/ログアウト URL を生成するユーティリティ。
 * 各画面に散在していたログインURL参照をここに集約する。
 *
 * env は呼び出し時に都度読む（モジュール top-level で固定化しない）。
 *
 * 自前ログイン画面導入後は、/callback（Hosted UI からの戻り先）専用。他画面からは呼ばない。
 */

const domain = (): string => process.env.REACT_APP_COGNITO_DOMAIN ?? '';
const clientId = (): string => process.env.REACT_APP_COGNITO_CLIENT_ID ?? '';
const redirectUri = (): string => process.env.REACT_APP_COGNITO_REDIRECT_URI ?? '';

/**
 * Cognito Hosted UI のログイン URL（authorization_code フロー）。
 */
export const getLoginUrl = (): string => {
  const params = new URLSearchParams({
    client_id: clientId(),
    response_type: 'code',
    scope: 'openid email profile',
    redirect_uri: redirectUri(),
  });
  return `${domain()}/login?${params.toString()}`;
};

/**
 * Cognito Hosted UI のログアウト URL。
 * logout_uri は redirect_uri から末尾の /callback を除いたアプリルート。
 */
export const getLogoutUrl = (): string => {
  const params = new URLSearchParams({
    client_id: clientId(),
    logout_uri: redirectUri().replace('/callback', ''),
  });
  return `${domain()}/logout?${params.toString()}`;
};
